(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-brand-foundation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanProductCopy = () => {
      const pattern = /^[\s\u2728\u{1F3A8}\u{1F46D}\u{1F381}\u23F1\uFE0F]+/u;
      document.querySelectorAll('product-information li, .product-information li').forEach((item) => {
        item.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = node.textContent.replace(pattern, '').trimStart();
        });
      });
    };
    const reveal = () => {
      const items = document.querySelectorAll('[data-cm-reveal]:not([data-cm-ready])');
      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('cm-is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('cm-is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
      items.forEach((item) => {
        item.setAttribute('data-cm-ready', 'true');
        observer.observe(item);
      });
    };
    const init = () => { cleanProductCopy(); reveal(); };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cm-product-personalization"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountPersonalization = () => {
      document.querySelectorAll('[data-cm-personalization-section]:not([data-cm-ready])').forEach((section) => {
        const productInformation = document.querySelector('product-information, .product-information');
        const productForm = productInformation && productInformation.querySelector('form[data-type="add-to-cart-form"]');
        const template = section.querySelector('[data-cm-personalization-template]');
        if (!productInformation || !productForm || !template) return;

        const field = template.content.firstElementChild.cloneNode(true);
        const nameInput = field.querySelector('input');
        const buttons = productForm.querySelector('.product-form-buttons') || productForm.lastElementChild;
        field.hidden = true;
        nameInput.disabled = true;
        buttons.before(field);

        const update = () => {
          const checkedValues = Array.from(productInformation.querySelectorAll('input[type="radio"]:checked'))
            .map((input) => `${input.value} ${input.labels ? Array.from(input.labels).map((label) => label.textContent).join(' ') : ''}`);
          const selectedValues = Array.from(productInformation.querySelectorAll('select'))
            .map((select) => `${select.value} ${select.selectedOptions[0] ? select.selectedOptions[0].textContent : ''}`);
          const isPersonalized = checkedValues.concat(selectedValues).join(' ').toLowerCase().includes('personnalis');
          field.hidden = !isPersonalized;
          nameInput.disabled = !isPersonalized;
          nameInput.required = isPersonalized;
          if (!isPersonalized) nameInput.value = '';
        };

        productInformation.addEventListener('change', () => window.setTimeout(update, 30));
        productForm.addEventListener('submit', (event) => {
          update();
          if (!nameInput.disabled && !nameInput.reportValidity()) event.preventDefault();
        }, true);
        section.setAttribute('data-cm-ready', 'true');
        update();
      });
    };

    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', mountPersonalization) : mountPersonalization();
    document.addEventListener('shopify:section:load', mountPersonalization);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
